import { clientMount } from '@vp/ubik-fragment-react';
import { Fragment } from '../fragments/logo-inspiration';
import type { MountWithRootOptions } from '@vp/ubik-fragment-types';
import type { Props } from '../fragments/logo-inspiration';

export const mount: MountWithRootOptions<Props> = async (rootElement, renderProps, rootOptions) => {
    return clientMount(<Fragment {...renderProps} />, rootElement, rootOptions);
};
